<template>
  <b-popover
    ref="popover"
    target="popover-reactive-1"
    triggers="hover"
    placement="auto"
    container="my-container"
  >
    <template #title>
      <div class="d-flex justify-content-between align-items-center">
        <span>{{ $t('DEBTIA_CLIENT_DETAILS') }}</span>
      </div>
    </template>
    <table
      class="client-details-table"
    >
      <tr
        class="business-item"
      >
        <td class="left-item-padding">
          {{ $t('DEBTIA_USERNAME') }}</td>
        <td class="right-values item-padding">
          {{ currentHoverClient.username }}
        </td>
      </tr>
      <tr
        class="business-item"
      >
        <td class="left-item-padding">
          {{ $t('DEBTIA_NAME') }}</td>
        <td class="right-values item-padding">
          {{ currentHoverClient.name }}
        </td>
      </tr>
      <tr
        class="business-item"
      >
        <td class="left-item-padding">
          {{ $t('DEBTIA_EMAIL') }}</td>
        <td class="right-values item-padding">
          <a :href="'mailto:' + currentHoverClient.email">{{ currentHoverClient.email }}</a>
        </td>
      </tr>
      <tr
        class="business-item"
      >
        <td class="left-item-padding">
          {{ $t('DEBTIA_PHONE') }}</td>
        <td class="right-values item-padding">
          {{ currentHoverClient.phone }}
        </td>
      </tr>
      <tr
        class="business-item"
      >
        <td class="left-item-padding">
          {{ $t('DEBTIA_CLIENT_TYPE') }}</td>
        <td class="right-values item-padding">
          {{ currentHoverClient.type ? currentHoverClient.type : 'N/A' }}
        </td>
      </tr>
      <tr
        v-if="currentHoverClient.type === 'person'"
        class="business-item"
      >
        <td class="left-item-padding">
          {{ $t('DEBTIA_CPR') }}</td>
        <td class="right-values item-padding">
          {{ currentHoverClient.cpr }}
        </td>
      </tr>
      <tr
        v-else
        class="business-item"
      >
        <td class="left-item-padding">
          {{ $t('DEBTIA_CVRCPR') }}</td>
        <td class="right-values item-padding">
          {{ currentHoverClient.cvrcpr }}
        </td>
      </tr>
      <tr
        class="business-item"
      >
        <td class="left-item-padding">
          {{ $t('DEBTIA_LOGIN') }}</td>
        <td class="right-values item-padding">
          {{ currentHoverClient.loginStatus === '1' ? 'Allowed' : 'Not Allowed' }}
        </td>
      </tr>
      <tr
        class="business-item"
      >
        <td class="left-item-padding">
          {{ $t('DEBTIA_BILLING_EMAIL') }}</td>
        <td class="right-values item-padding">
          <a :href="'mailto:' + currentHoverClient.billing_email">{{ currentHoverClient.billing_email ? currentHoverClient.billing_email : 'N/A' }}</a>
        </td>
      </tr>
      <tr
        class="business-item"
      >
        <td class="left-item-padding">
          {{ $t('DEBTIA_CONTACT_PERSON') }}</td>
        <td class="right-values item-padding">
          {{ currentHoverClient.contact_person ? currentHoverClient.contact_person : 'N/A' }}
        </td>
      </tr>
    </table>
    <table
      :class="currentHoverClient.billing_address ? '' : 'table-border'"
      class="client-addressdetails-table"
    >
      <tr
        class="business-item"
      >
        <td class="left-item-padding">
          <h5>{{ $t('DEBTIA_ADDRESS') }}</h5></td>
      </tr>
      <tr
        class="business-item"
      >
        <td class="left-item-padding">
          {{ $t('DEBTIA_HOUSE_NUMBER') }}</td>
        <td class="right-values item-padding">
          {{ currentHoverClient.address.house_number ? currentHoverClient.address.house_number : 'N/A' }}
        </td>
      </tr>
      <tr
        class="business-item"
      >
        <td class="left-item-padding">
          {{ $t('DEBTIA_ROAD_NAME') }}</td>
        <td class="right-values item-padding">
          {{ currentHoverClient.address.road_name ? currentHoverClient.address.road_name : 'N/A' }}
        </td>
      </tr>
      <tr
        class="business-item"
      >
        <td class="left-item-padding">
          {{ $t('DEBTIA_PLACE_NAME') }}</td>
        <td class="right-values item-padding">
          {{ currentHoverClient.address.place ? currentHoverClient.address.place : 'N/A' }}
        </td>
      </tr>
      <tr
        class="business-item"
      >
        <td class="left-item-padding">
          {{ $t('DEBTIA_ZIP_CODE') }}</td>
        <td class="right-values item-padding">
          {{ currentHoverClient.address.zip_code ? currentHoverClient.address.zip_code : 'N/A' }}
        </td>
      </tr>
      <tr
        class="business-item"
      >
        <td class="left-item-padding">
          {{ $t('DEBTIA_CITY') }}</td>
        <td class="right-values item-padding">
          {{ currentHoverClient.address.city ? currentHoverClient.address.city : 'N/A' }}
        </td>
      </tr>
      <tr
        class="business-item"
      >
        <td class="left-item-padding">
          {{ $t('DEBTIA_COUNTRY') }}</td>
        <td class="right-values item-padding">
          {{ currentHoverClient.address.country ? currentHoverClient.address.country : 'N/A' }}
        </td>
      </tr>
    </table>
    <table
      v-if="currentHoverClient.billing_address"
      class="client-addressdetails-table table-border"
    >
      <tr
        class="business-item"
      >
        <td class="left-item-padding">
          <h5>{{ $t('DEBTIA_BILLING_ADDRESS') }}</h5></td>
      </tr>
      <tr
        class="business-item"
      >
        <td class="left-item-padding">
          {{ $t('DEBTIA_HOUSE_NUMBER') }}</td>
        <td class="right-values item-padding">
          {{ currentHoverClient.billing_address ? currentHoverClient.billing_address.house_number : 'N/A' }}
        </td>
      </tr>
      <tr
        class="business-item"
      >
        <td class="left-item-padding">
          {{ $t('DEBTIA_ROAD_NAME') }}</td>
        <td class="right-values item-padding">
          {{ currentHoverClient.billing_address.road_name ? currentHoverClient.billing_address.road_name : 'N/A' }}
        </td>
      </tr>
      <tr
        class="business-item"
      >
        <td class="left-item-padding">
          {{ $t('DEBTIA_PLACE_NAME') }}</td>
        <td class="right-values item-padding">
          {{ currentHoverClient.billing_address.place ? currentHoverClient.billing_address.place : 'N/A' }}
        </td>
      </tr>
      <tr
        class="business-item"
      >
        <td class="left-item-padding">
          {{ $t('DEBTIA_ZIP_CODE') }}</td>
        <td class="right-values item-padding">
          {{ currentHoverClient.billing_address.zip_code ? currentHoverClient.billing_address.zip_code : 'N/A' }}
        </td>
      </tr>
      <tr
        class="business-item"
      >
        <td class="left-item-padding">
          {{ $t('DEBTIA_CITY') }}</td>
        <td class="right-values item-padding">
          {{ currentHoverClient.billing_address.city ? currentHoverClient.billing_address.city : 'N/A' }}
        </td>
      </tr>
      <tr
        class="business-item"
      >
        <td class="left-item-padding">
          {{ $t('DEBTIA_COUNTRY') }}</td>
        <td class="right-values item-padding">
          {{ currentHoverClient.billing_address.country ? currentHoverClient.billing_address.country : 'N/A' }}
        </td>
      </tr>
    </table>
    <b-button
      v-if="$ability.can(constants.action.permissionClientEdit, constants.resource.client)"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="outline-primary"
      :to="{ name: 'client-view', params: { id: currentHoverClient.id } }"
      target="_blank"
      class="edit-client-btn"
    >
      {{ $t("DEBTIA_VIEW_MORE") }}
      <feather-icon
        icon="ExternalLinkIcon"
      />
    </b-button>
  </b-popover>
</template>

<script>
import constants from '@/app-configs/constants'
import Ripple from 'vue-ripple-directive'

import {
  BButton,
  BPopover,
} from 'bootstrap-vue'

export default {
  components: {
    BButton,
    BPopover,
  },
  directives: {
    Ripple,
  },
  props: {
    currentHoverClient: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      constants,
    }
  },
  watch: {
  },
  created() {
  },
  methods: {
  },
}
</script>

<style lang="scss">
</style>
